import { useEffect } from 'react';

const useCountdown = ({ start, stop, countDown, setCountDown }) => {
  useEffect(() => {
    let interval = null;
    if (start && countDown > 0) {
      interval = setInterval(() => {
        setCountDown((prev) => prev - 1);
      }, 1000);
    }

    if (countDown === 0) {
      clearInterval(interval);
      stop();
    }

    return () => {
      clearInterval(interval);
    };
  }, [start, countDown]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  const minutes = String(Math.floor((countDown % (60 * 60)) / 60)).padStart(
    2,
    '0'
  );
  const seconds = String(Math.floor(countDown % 60)).padStart(2, '0');

  return [minutes, seconds];
};

export { useCountdown };
